import api from "../utils/axiosConfig";

export interface Contact {
  locale: string;
  message: string;
  /** Where Top Up, Withdraw and Support send the player — a chat link or form. */
  url: string;
  /**
   * The number to reach customer service on, beside `url` rather than instead
   * of it.
   *
   * **Empty string when no number is published**, which is a real answer: an
   * operator who works through chat alone leaves it blank. Show the link by
   * itself in that case rather than a call button that dials nothing.
   */
  contactNum: string;
  reviewNotice: string;
  /** Where a player under review is sent to ask about it. */
  reviewUrl: string;
  /** The number to ask about a review on, or empty. See `contactNum`. */
  reviewContactNum: string;
  updatedAt: string | null;
  messages: Record<string, string>;
  reviewNotices: Record<string, string>;
}

export const getContact = (locale: string): Promise<Contact> =>
  api.get<Contact>("/contact", { params: { locale } }).then((response) => response.data);

export interface RulesGuideSection {
  heading: string;
  body: string;
}

export interface RulesGuide {
  locale: string;
  version: number;
  updatedAt: string | null;
  title: string;
  intro: string;
  sections: RulesGuideSection[];
}

export const getRulesGuide = (locale: string): Promise<RulesGuide> =>
  api.get<RulesGuide>("/rules/guide", { params: { locale } }).then((response) => response.data);
